import { httpClient } from '@/repositories/httpClient';
export class BookRepository {
}
BookRepository.get = async (params) => {
    const { data } = await httpClient.get('/', { params });
    return data;
};
BookRepository.find = async (id) => {
    const { data } = await httpClient.get(`/${id}`);
    return data;
};
